import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=15265c08&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
import style0 from "./Admin.vue?vue&type=style&index=0&id=15265c08&prod&lang=scss&"
import style1 from "./Admin.vue?vue&type=style&index=1&id=15265c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15265c08",
  null
  
)

export default component.exports